import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import {Route, HashRouter} from 'react-router-dom';
import Login from "./components/login";
import Signup from "./components/signup";
import Registered from "./components/Success";
import forgotPWD from "./components/forgotpwd";
import App from "./App";
const createBrowserHistory =require("history").createBrowserHistory; 
const customHistory = createBrowserHistory();
const CustomRoutes = ()=>
    <HashRouter history={customHistory}>
            <App/>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/Success" component={Registered} />
            <Route exact path="/forgotpwd" component={forgotPWD} />

        </HashRouter>
    
    
export default CustomRoutes;